import React, { useEffect, useRef, useState } from "react";
import pestTypeList from "../../variables/pestTypeList";
import DamageTypeCarousel from "components/DamageTypeCarousel/DamageTypeCarousel";
import "./DamageType.css";

const DamageType = (props) => {
  const [damageType, setDamageType] = useState("Mortality");
  const [damageDescription, setDamageDescription] = useState("");
  const [damageTypeExpand, setDamageTypeExpand] = useState(false);
  const initialLoad = useRef(true);
  const announcement = useRef(null);

  useEffect(() => {
    const result = pestTypeList.filter((item) => item.Category === damageType);
    setDamageDescription(result[0].Description);
    if (initialLoad.current) {
      initialLoad.current = false;
    } else {
      announcement.current = damageType + " tab now visible";
    }
  }, [damageType]);

  return (
    <div className="usa-accordion damage-type">
      <button
        type="link"
        className="usa-accordion__button usa-accordion-button"
        aria-expanded="false"
        aria-controls="DamageType"
        onClick={() => {
          setDamageTypeExpand((previousValue) => !previousValue);
        }}
      >
        Select for a description of damage types{" "}
        <i
          className={
            (damageTypeExpand ? "fas fa-caret-up" : "fas fa-caret-down") +
            " carousel__i"
          }
        ></i>
      </button>
      <div id="DamageType" className="usa-accordion__content" hidden>
        <div className="col-md-7 carousel-header">
          <div className="damage-type-buttons">
            <button
              onClick={() => {
                setDamageType("Mortality");
              }}
            >
              Mortality
            </button>
            <button
              onClick={() => {
                setDamageType("Defoliation");
              }}
            >
              Defoliation
            </button>
            <button
              onClick={() => {
                setDamageType("Other");
              }}
            >
              Other
            </button>
          </div>
          <div className="visually-hidden" aria-live="polite">
            {announcement.current}
          </div>
          <h2>{damageType}</h2>
          <div>{damageDescription}</div>
          <DamageTypeCarousel
            selectedDamageType={damageType}
          ></DamageTypeCarousel>
        </div>
      </div>
    </div>
  );
};

export default DamageType;
